import React from 'react';
import PropTypes from 'prop-types';

import {Alert, Box, Chip, Divider, Stack, Typography} from 'views/components';
import {translate} from 'views/module';

import {translateOr} from 'views/scenes/loom_lead/detail/client_scenes/client_feed/format';

// The read-only copy of the caregiver Clients tab, like the lead page's Caregivers tab. It lists
// Loom's client assignments and has no add-client dialog or remove action.
const LoomCaregiverClients = (props) => {
  const {clientAssignments} = props;

  if (clientAssignments.length === 0) {
    return (
      <Box sx={{p: 2}}>
        <Alert severity='info'>{translate('caregiver.LoomCaregiverDetail.Clients.Empty')}</Alert>
      </Box>
    );
  }

  return (
    <Stack>
      {
        clientAssignments.map((assignment) => (
          <Box key={assignment.assignmentId}>
            <Divider />
            <Stack direction="row" alignItems="center" spacing={2} sx={{p: 2}}>
              <Chip
                label={translateOr(`loomLead.LoomLeadDetail.CaregiverConnections.Status.${assignment.status}`, assignment.status)}
                sx={{
                  backgroundColor: assignment.status === 'ACTIVE' ? '#FFE0CC' : '#FFD54F',
                  color: '#000',
                }}
              />
              <Stack>
                <Typography variant="subtitle1" sx={{fontWeight: 600}}>
                  {translate('caregiver.LoomCaregiverDetail.Clients.ClientName')}
                </Typography>
                <Typography sx={{fontSize: '14px'}}>
                  {assignment.clientName || '-'}
                </Typography>
              </Stack>
            </Stack>
          </Box>
        ))
      }
    </Stack>
  );
};
LoomCaregiverClients.propTypes = {
  clientAssignments: PropTypes.arrayOf(PropTypes.shape({
    assignmentId: PropTypes.string.isRequired,
    clientName: PropTypes.string,
    status: PropTypes.string,
  })).isRequired,
};

export default React.memo(LoomCaregiverClients);
